import { defineStore } from "pinia";

export const useEmailStore = defineStore('email', {
    state: () => ({
        email: {},
        emails: [],
    }),
    actions: {
        setEmail(email) {
            this.email = email
        },
        setEmails(emails) {
            this.emails = emails
        },
        addEmail(email) {
            this.emails.unshift(email)
        },
        updateEmail(email) {
            let index = this.emails.findIndex(cl => cl.id === email.id)
            this.emails.splice(index, 1, email)
        },
        deleteEmail(email) {
            let index = this.emails.findIndex(cl => cl.id === email.id)
            this.emails.splice(index, 1)
        },
    },
});